import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailsRows } from 'UI';
import { formattedCurrency, Card } from 'vopay';
import { getProductLabel } from '../utils/fileProcessingUtils';
import { useClientData } from '@/providers/ClientData.provider';
import { FileUploadProduct, FileUploadService } from '../types';

type FileUploadHeaderProps = {
  product: FileUploadProduct;
  service: FileUploadService;
  fileName: string;
  numberOfTransactions: number;
  amount: number;
  currency: string;
};

type FC = FunctionComponent<FileUploadHeaderProps>;

const FileUploadHeader: FC = (props: FileUploadHeaderProps) => {
  const { product, service, fileName, numberOfTransactions, amount, currency } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.Review.Header' });
  const {
    response: { Country },
  } = useClientData();

  // Handle currency default based on account country
  const displayCurrency = currency || (Country === 'US' ? 'USD' : 'CAD');

  const details = [
    {
      label: t('transferType'),
      value: service,
    },
    {
      label: t('paymentRail'),
      value: getProductLabel(product),
    },
    {
      label: t('currency'),
      value: displayCurrency,
    },
    {
      label: t('fileName'),
      value: fileName,
    },
    {
      label: t('numberOfTransactions'),
      value: numberOfTransactions,
    },
    {
      label: t('totalAmount'),
      value: `$${formattedCurrency(amount.toString() || '')}`,
    },
  ];

  return (
    <Card>
      <DetailsRows details={details} />
    </Card>
  );
};

export default FileUploadHeader;
